import { render, staticRenderFns } from "./SectionSelector.vue?vue&type=template&id=1bb7d278&scoped=true&"
import script from "./SectionSelector.vue?vue&type=script&lang=js&"
export * from "./SectionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7d278",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsOfferSectionsSectionHomepage: require('/app/components/sections/offer/sections/SectionHomepage.vue').default,SectionsOfferSectionsSectionOffer: require('/app/components/sections/offer/sections/SectionOffer.vue').default,SectionsProjectSectionSpecs: require('/app/components/sections/project/SectionSpecs.vue').default,SectionsProjectSectionLocation: require('/app/components/sections/project/SectionLocation.vue').default,SectionsProjectSectionContact: require('/app/components/sections/project/SectionContact.vue').default})
